"use strict";

define('rs/header/header.view',['vertebrae', 'evisions/evimenu/evimenu', 'rs/helper'], function (Vertebrae, EVIMenu, helper) {
  var HeaderView = Vertebrae.View.extend({
    templates: {
      'header.init': 'renderInitFragment',
      'header.navigation.popup': 'renderNavPopup'
    },
    events: {
      'click .persona-menu': 'handlePersonaMenuClick',
      'click .nav-link': 'handleNavLinkClick',
      'click .navigation-popup-btn': 'handleNavPopupClick',
      'click .has-submenu': 'handleSubmenuPopupItemClick',
      'click .header-logo': 'handleHeaderLogoClick',
      'click .badge-container': 'handleNotificationsClick'
    },
    render: function render() {
      this.$el.html(this.renderInitFragment(this.getDelegate().getTemplateProperties()));
    },
    selectActiveNavByIndex: function selectActiveNavByIndex(index) {
      var navs = this.getNavigationElement().find('.nav-link');
      navs.removeClass('active');
      if (index != null) {
        navs.eq(index).addClass('active');
      }
    },
    selectNavByRoute: function selectNavByRoute(route) {
      var navs = this.getNavigationElement().find('.nav-link'),
        navRoute = null,
        len = navs.length,
        i = 0;
      navs.removeClass('active');
      for (i = 0; i < len; ++i) {
        navRoute = navs.eq(i).data('route');
        if (navRoute == route) {
          navs.eq(i).addClass('active');
          break;
        }
      }
    },
    getNavigationElement: function getNavigationElement() {
      return this.$('.product-navigation');
    },
    handleNavLinkClick: function handleNavLinkClick(ev) {
      var el = $(ev.currentTarget),
        route = $(ev.currentTarget).data('route'),
        link = $(ev.currentTarget).data('link');
      if (el.hasClass('menu-children')) {
        var menuIndex = el.data('menu-index'),
          children = this.getDelegate().getAppController().getNavigationLinks()[menuIndex].children;
        EVIMenu.show({
          element: el,
          container: el,
          className: 'header-menu',
          template: 'header.submenu.item',
          horizontal: 'left',
          caret: 'top-left',
          offset: {
            top: 45,
            left: 0
          }
        }, children);
      } else if (link) {} else if (route) {}
    },
    handleHeaderLogoClick: function handleHeaderLogoClick(ev) {
      var appLinks = this.getDelegate().getApplicationLinks(),
        el = $(ev.currentTarget);
      if (appLinks && appLinks.length) {
        EVIMenu.show({
          element: el,
          container: el,
          className: 'header-menu',
          template: 'header.submenu.item',
          horizontal: 'left',
          caret: 'top-left',
          offset: {
            top: 41,
            left: 0
          }
        }, appLinks);
      }
    },
    handlePersonaMenuClick: function handlePersonaMenuClick() {
      var personaMenu = this.$('.persona-menu'),
        personaIcon = $('div.persona-menu .glyphicon'),
        rightOffset = $('body').width() - (personaIcon.position().left + 36),
        delegate = this.getDelegate();
      EVIMenu.show({
        element: personaMenu,
        container: personaMenu,
        className: 'header-menu',
        template: 'header.submenu.item',
        horizontal: 'left',
        offset: {
          top: 45,
          right: rightOffset
        }
      }, [{
        name: 'Log Out'
      }]).then(function (index) {
        switch (index) {
          case 0:
            delegate.requestLogout();
            break;
        }
      });
    },
    handleSubmenuPopupItemClick: function handleSubmenuPopupItemClick(ev) {
      if ($(ev.toElement).hasClass('has-submenu')) {
        ev.stopPropagation();
      }
    },
    handleNavPopupClick: function handleNavPopupClick(ev) {
      if (!this._showingMenu) {
        var el = $(ev.currentTarget),
          that = this;
        var html = this.renderNavPopup({
          menus: this.getDelegate().getNavigationLinks()
        });
        el.popover({
          animation: false,
          html: true,
          placement: 'bottom',
          content: html,
          delay: 0
        }).popover('show');
        this._showingMenu = true;
        _.defer(function () {
          $(document.body).one('click', function (ev) {
            el.popover('destroy');
            that._showingMenu = false;
          });
        });
      }
    },
    getBadgePosition: function getBadgePosition(name) {
      var offset = this.getBadgeByName(name).find('.badge-icon').offset() || {};
      offset.right = window.innerWidth - offset.left;
      return offset;
    },
    getBadgeByName: function getBadgeByName(name) {
      return this.$('.badge-container[data-name="' + name + '"]');
    },
    showBadgeCount: function showBadgeCount(name) {
      return this.getBadgeByName(name).find('.badge-count').show();
    },
    hideBadgeCount: function hideBadgeCount(name) {
      return this.getBadgeByName(name).find('.badge-count').hide();
    },
    setBadgeCount: function setBadgeCount(name, count) {
      return this.getBadgeByName(name).find('.badge-count').text(count);
    },
    activateNotifications: function activateNotifications(name) {
      return this.getBadgeByName(name).addClass('active');
    },
    deactivateNotifications: function deactivateNotifications(name) {
      return this.getBadgeByName(name).removeClass('active');
    },
    handleNotificationsClick: function handleNotificationsClick(ev) {
      var el = $(ev.currentTarget),
        name = el.data('name');
      if (name) {
        this.getDelegate().trigger('toggle:' + name);
      }
    }
  });
  return HeaderView;
});

